import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { LayoutService } from '../../services/layout.service';

@Component({
    selector: 'app-topbar',
    templateUrl: './topbar.component.html'
})
export class TopBarComponent implements OnInit {

    public items: MenuItem[] = [];

    constructor(
        public layoutService: LayoutService,
        private router: Router,
    ) { }

    ngOnInit(): void {
        this.items = [
            {
                label: 'User Profile',
                icon: 'pi pi-user',
                routerLink: ['/user/profile']
            },
            {
                label: 'Logout',
                icon: 'pi pi-power-off',
                command: () => {
                    this.router.navigate(['/auth/login']);
                }
            }
        ];
    }
    

}
